// constants/personalConstants.js
export const districts = [
    "Голосіївський", 
    "Дарницький", 
    "Деснянський", 
    "Дніпровський", 
    "Оболонський", 
    "Печерський", 
    "Подільський", 
    "Святошинський", 
    "Солом'янський", 
    "Шевченківський"
];

export const mainTableHeaders = [
    { key: 'number', label: '№' },
    { key: 'district', label: 'Район' },
    { key: 'kindergarten', label: 'ЗДО' },
    { key: 'tech_male', label: 'чоловіків' },
    { key: 'tech_female', label: 'жінок' },
    { key: 'tech_total', label: 'загалом' },
    { key: 'ped_male', label: 'чоловіків' },
    { key: 'ped_female', label: 'жінок' },
    { key: 'ped_total', label: 'загалом' }
];

export const detailTableHeaders = [
    { key: 'number', label: '№' },
    { key: 'position', label: 'Найменування професії' },
    { key: 'male', label: 'Чоловіків' },
    { key: 'female', label: 'Жінок' },
    { key: 'total', label: 'Загалом' }
];